import React, {Fragment} from 'react';
import Box from '../layout/Box';
import createEditor from '../form/ComponentEditor';
import userForm from "./forms/userForm";
import userList from "./lists/userList";
import classNames from "classnames";
import Button from "../form/Button";
import SelectorGrid from "../form/SelectorGrid/SelectorGrid";
import MembercardEditor from "./MembercardEditor";
import ModalEditor from "./ModalEditor";
import Modal from "../layout/Modal";
import Portal from '../layout/Portal';
import UserPrivileges from '../form/UserPrivileges';

class userEditor extends React.Component {

    state = {
        deleteData: false
    }

    createForgottenPassword = async () => {
        await this.props.processAction(async ({componentAction}) => {
            componentAction("forgottenpw", {email: this.props.values.email});
        });
    }

    deletePersonalData = async () => {
        this.setState({deleteData: false});
        await this.props.processAction(async ({componentAction}) => {
            componentAction("deletePersonalData");
        });
    }

    deleteModalShow = () => {
        this.setState({deleteData: true});
    }

    render() {
        const UserForm = userForm;
        const UserList = userList;
        const sortable = true;
        const filterable = true;
        return (
            <Fragment>
                <Box
                    theme="default"
                >
                    <UserList {...this.props} />
                </Box>
                <Box
                    theme="default"
                    footer={[
                        <Button key="1" disabled={this.props.isLoading} color="default" className="pull-left" onClick={ this.props.pristineForm }>
                            Új
                        </Button>,
                        <div className="pull-right">
                            <Button key="2" disabled={ this.props.isLoading || !this.props.values.email } color="default" onClick={ this.createForgottenPassword }>
                                Új jelszó küldése
                            </Button>
                            <Portal key="4">
                                <Modal

                                    state={this.state.deleteData ? "on" : "off"}
                                    theme="default"
                                    size="medium"
                                    header="Biztos törlöd a felhasználói adatokat?"
                                    buttons={[
                                        {
                                            text: 'Mégse',
                                            props: {color: "default", disabled: this.props.disabled || this.props.isLoading},
                                            onClose: true,
                                            onClick: async () => {
                                                try {
                                                    this.setState({deleteData: false});
                                                } catch (e) {

                                                }
                                            }
                                        },
                                        {
                                            text: 'Igen',
                                            props: {color: "primary", disabled: this.props.disabled || this.props.isLoading},
                                            onClick: async () => {
                                                await this.deletePersonalData();
                                            }
                                        }
                                    ]}
                                > A törlés után a felhasználó összes személyes adata, törzsvásárlói kártyája, elérhetősége törlődik.
                                </Modal>
                            </Portal>
                            <Button key="3" disabled={ this.props.isLoading } color="danger" onClick={ this.deleteModalShow }>
                                Személyes adatok törlése
                            </Button>
                            <Button key="0" disabled={ !this.props.dirty || this.props.isLoading } color="primary" onClick={ this.props.saveForm }>
                                Mentés
                            </Button>
                        </div>
                    ]}
                >
                    <UserForm {...this.props} />
                </Box>
                {this.props.values[this.props.componentConfig.idfield] && <MembercardEditor
                    editorContext="userMembercardEditor"
                    gridid="userMembercardList"
                    editor={ModalEditor}
                    pageSize={0}
                    listFilter={[
                        {field: "user", value: this.props.values[this.props.componentConfig.idfield]}
                    ]}
                />}
                {this.props.values[this.props.componentConfig.idfield] && <Box
                    theme="default"
                    header="Jogosultságok"
                >
                    <UserPrivileges {...this.props} />
                </Box>}
            </Fragment>
        );
    }
}
export default createEditor({componentName: "user", WrappedComponent: userEditor, props: {view: "admin"}});

